import React from 'react';
import BottomSheet from 'components/BottomSheet';
import Icon from 'components/Icon';
import Form from './Form';

type AppProps = {
  open: boolean;
  /** The combined document id (used for the email endpoints). */
  documentId: number;
  closeModal: () => any;
};

// PRISM-434: preview shown before emailing a combined document's signing link
// to a signer. Mirrors the "Email Document" bottom sheet so the experience
// matches "Enable Signatures" on normal documents.
const SendSignaturePacket: React.FC<AppProps> = ({
  open,
  documentId,
  closeModal,
}) => {
  return (
    <BottomSheet open={open} maxWidth="max-w-3xl">
      <div className="pb-4">
        <div className="flex justify-between">
          <div className="page-heading">Send Signature Packet</div>
          <div>
            <Icon
              name="close"
              size={32}
              onClick={closeModal}
              className="cursor-pointer"
            />
          </div>
        </div>
        <div className="text-sm text-text-medium mt-1">
          Review the email below, then send the recipient a secure link to
          review and sign this document remotely.
        </div>
      </div>
      {open && <Form documentId={documentId} onSuccess={closeModal} />}
    </BottomSheet>
  );
};

export default SendSignaturePacket;
